// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1TExi","tab":"Tabs_tab__1RYgQ","tabActive":"Tabs_tabActive__8nQ56"};